var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.577952V13.4225V0.577952ZM0.5 0.577952C0.507274 0.573154 0.521459 0.566895 0.541711 0.566895C0.561999 0.566895 0.576178 0.573165 0.583422 0.577947V13.4225C0.582245 13.4233 0.580832 13.4241 0.579152 13.425C0.557621 13.4364 0.525835 13.4364 0.504297 13.425L0.5 0.577952ZM8.55229 5.88391L12.4791 9.46887C12.4728 9.47053 12.4656 9.47163 12.4577 9.47171H2.66677V1.55744H12.4577C12.4656 1.55753 12.4728 1.55862 12.4791 1.56028L8.55228 5.14539L8.14782 5.51465L8.55229 5.88391ZM12.5025 9.45782C12.5034 9.45621 12.5038 9.45616 12.5028 9.45713C12.5029 9.45676 12.5031 9.4564 12.5032 9.45607L12.5025 9.45782Z",
    stroke: "#C6CCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFlag);
export default __webpack_public_path__ + "static/media/InactiveFlag.2091f41028d33e2d7c6da3732dab0554.svg";
export { ForwardRef as ReactComponent };